export class BidirectionalIterator<T> {
  private index: number|null = null;

  constructor(private items: T[]) {}

  static fromIterator<T>(iterator: Iterator<T>): BidirectionalIterator<T> {
    const items: T[] = [];
    let result = iterator.next();
    while (!result.done) {
      items.push(result.value);
      result = iterator.next();
    }
    return new BidirectionalIterator(items);
  }

  next(): IteratorResult<T> {
    if (this.index === null) {
      this.index = 0;
    } else {
      this.index++;
    }
    if (this.index < this.items.length) {
      return { value: this.items.at(this.index)!, done: false };
    }
    this.index = this.items.length;
    return { value: undefined, done: true };
  }

  back(): IteratorResult<T> {
    if (this.index !== null && this.index > 0) {
      return { value: this.items.at(--this.index)!, done: false };
    }
    return { value: undefined, done: true };
  }

  current(): T | undefined {
    return this.index !== null ? this.items.at(this.index) : undefined;
  }
}
